<template>
    <tabs class="my-tabs">
        <tab title="推荐阅读">
            <RecommendRead></RecommendRead>
        </tab>
        <tab title="近期发布">
            <RecentlyRelease></RecentlyRelease>
        </tab>
        <tab title="优质用户">
            <ExcellentUser></ExcellentUser>
        </tab>
    </tabs>
</template>

<script>
	import {Tabs, Tab} from './../../common/js/TabComponent.js'
    import RecentlyRelease from './recentlyRelease.vue'
    import RecommendRead from './recommendRead.vue'
    import ExcellentUser from './excellentUser.vue'

	export default {
	  	data() {
		    return {

		    }
	  	},
	  	components: {
		    Tabs,
		    Tab,
            RecentlyRelease,
            RecommendRead,
            ExcellentUser
  		},      
        mounted(){
            // console.log(this.tabTitle)
        },
        methods: {

        }
	}
</script>

<style src="./../../common/css/homepageTab.css"></style>
<style>
    .my-tabs {
        font-size: 0.3rem;
    }
</style>




// WEBPACK FOOTER //
// src/components/homepage/tab.vue